/**
 * The two constants both apps need to agree on.
 *
 * They live in the engine because "agree on" is the whole point: a public key
 * that differs between web and mobile means a code bought on one platform is
 * rejected by the other, which is the exact failure this design exists to
 * avoid. Neither value is a secret — the key is the *public* half, and the
 * origin is visible in any network log.
 */

/**
 * The public half of the licence signing key, hex. Generated once by
 * `npm run license:keygen`; its private counterpart lives only in the
 * worker's secret store.
 *
 * Changing this invalidates every unlock code ever issued.
 */
export const LICENSE_PUBLIC_KEY = '5229c41e2a3ea2dd8bed7c032c8b527d6084913b8d019eb374c8993edc599e4a';

/**
 * Where a store receipt is traded for an unlock code. Contacted at most once
 * per purchase — never when checking a code that is already on the device.
 */
export const LICENSE_SERVICE_ORIGIN = 'https://license.nextcollage.com';
